import { faPollH, faRulerHorizontal } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon, Props } from "@fortawesome/react-fontawesome"
import React, { useCallback } from "react"
import styled from "styled-components"
import { Button } from "../../../../../../../../../../../../components/parts/buttons/button"
import {
  Modal,
  ModalDescription,
  ModalTitle,
} from "../../../../../../../../../../../../components/parts/modal"
import { SurveyModel } from "../../../../../../../../../../../../rpcs/dist/ChatRoomRPC"
import Color from "../../../../../../../../../../../../style/enum/color"

interface IProps {
  onClose: () => void
  onSelect: (type: SurveyModel) => void
}

export const SelectSurveyModel = (props: IProps) => {
  const onClickSelectSurvey = useCallback(
    () => props.onSelect(SurveyModel.Select),
    // eslint-disable-next-line
    [],
  )
  const onClickScaleSurvey = useCallback(
    () => props.onSelect(SurveyModel.Scale),
    // eslint-disable-next-line
    [],
  )

  return (
    <Modal onBackgroundClick={props.onClose}>
      <ModalTitle>アンケートの種類を選択してください</ModalTitle>
      <ModalDescription>
        <div>
          <StyledButton
            color={Color.DIMGRAY}
            borderColor={Color.DIMGRAY}
            onClick={onClickSelectSurvey}
          >
            <Icon icon={faPollH} /> 選択方式
          </StyledButton>
        </div>
        <div>
          <StyledButton
            color={Color.DIMGRAY}
            borderColor={Color.DIMGRAY}
            onClick={onClickScaleSurvey}
          >
            <Icon icon={faRulerHorizontal} /> スケール方式
          </StyledButton>
        </div>
      </ModalDescription>
    </Modal>
  )
}

const Icon = styled(FontAwesomeIcon).attrs<Props>({
  fixedWidth: true,
})`
  font-size: 1.5rem;
  color: ${Color.BRAND};
  display: block;
  width: 40px !important;
`

const StyledButton = styled(Button)`
  width: 100%;
  display: flex;
  margin: 24px 0;
`
